export let state = {
  giftIndex: 0,
  isAnotherGift: false,
  isEditingGift: false,
  isReturning: false,
  isTribute: false,
  preselectedFundOnly: false
};